const updateLoyaltyButtonText = () => {
  const loyaltySection = document.querySelector('.loyalty-rewards')

  const config = { childList: true, subtree: true };

  if(loyaltySection) {
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const rewardsButtons = document.querySelectorAll('.lion-claimed-reward-item__view-reward-button')
          if(rewardsButtons) {
            rewardsButtons.forEach(button => {
              button.textContent = 'View Rewards'
            })
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(loyaltySection, config);
  }
}

export default updateLoyaltyButtonText;